import { Component } from '@angular/core';
import { GamesGroupService, IPollQuestion, MemberQuery, PopulationQuery } from '@fgb/core';
import { map, Observable } from 'rxjs';
import { calculateAge, getKidType, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-polls-page',
  templateUrl: './polls-page.component.html',
  styleUrl: './polls-page.component.scss',
})
export class PollsPageComponent {
  pollsQuestion$: Observable<IPollQuestion[]>;
  populations = Populations;
  kidType$: Observable<KidTypeT>;
  isDefault: boolean;
  isKid: boolean;
  isClub1901: boolean;
  constructor(private gamesGroupService: GamesGroupService, private memberQuery: MemberQuery, private populationQuery: PopulationQuery) {}

  ngOnInit(): void {
    this.pollsQuestion$ = this.gamesGroupService.fetchPolls();
    this.kidType$ = this.memberQuery
      .selectMemberDetails()
      .pipe(map((m) => (m ? getKidType(calculateAge(new Date(m.DOB))) : 'Other')));
    this.isDefault = this.populationQuery.userInPopulation([Populations.Default]);
    this.isKid = this.populationQuery.userInPopulation([Populations.Kids]);
    this.isClub1901 = this.populationQuery.userInPopulation([Populations.Club1901]);
  }
}
